import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import parse from 'html-react-parser'

// Components
import Layout from '../components/layout'
import GradientHeader from '../components/GradientHeader'

// Slick
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const sliderSettings = {
  adaptiveHeight: true,
  autoplay: false,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
};

const CaseTemplate = ({ data: { prismicCaseStudy: caseNode } }) => {
  const { data } = caseNode;
  return (
    <Layout>
        <Helmet htmlAttributes={{ lang: 'en' }}>
            <title>Starlight Global | {data.title.text}</title>
            <meta name="description" content={`At Starlight Global, we've been working with purpose-driven organizations and non-profits of all sizes for years. Our diverse experience and the unique needs of our clients have made us experts on what works and what doesn't. Learn more about our work with ${data.title.text}`} />
        </Helmet>
        <div className="case">
          <GradientHeader header={data.title.text} subheader={data.subtitle.text} backButton="true" />
          <h3>Case Study</h3>
          <div className="case__wrap">
            <div className="case__content-wrap">
              {/* Client */}
              {data.client_descriptor.html ? (<>
                <p className="section-header">Client:</p>
                <div className="section-content" dangerouslySetInnerHTML={{ __html: data.client_descriptor.html }}></div>
              </>) : null}

              {data.tech_used.html ? (<>
                <p className="section-header">Tech Used:</p>
                <div className="section-content" dangerouslySetInnerHTML={{ __html: data.tech_used.html }}></div>
              </>) : null}

              {/* Project */}
              {data.project_goal.html ? (<>
                <p className="section-header">Project Goal:</p>
                <div className="section-content" dangerouslySetInnerHTML={{ __html: data.project_goal.html }}></div>
              </>) : null}

              {/* Process */}
              {data.process.html ? (<>
                <p className="section-header">Process:</p>
                <div className="section-content" dangerouslySetInnerHTML={{ __html: data.process.html }}></div>
              </>) : null}

              {/* Outcome */}
              {data.outcome.html ? (<>
                <p className="section-header">Outcome:</p>
                <div className="section-content" dangerouslySetInnerHTML={{ __html: data.outcome.html }}></div>
              </>) : null}
            </div>
            <div className="case__gallery-wrap">
              <Slider {...sliderSettings}>
                {caseNode.data.body &&
                  caseNode.data.body[0].items.map((galleryImage, key) => (
                    <div key={key}>
                      <img src={galleryImage.gallery_image.url} alt={data.title.text} />
                      </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
    </Layout>
  )
}

export default CaseTemplate

CaseTemplate.propTypes = {
  data: PropTypes.shape({
    prismicCaseStudy: PropTypes.object.isRequired,
  }).isRequired,
};

export const pageQuery = graphql`
  query CaseBySlug($uid: String!) {
    prismicCaseStudy(uid: { eq: $uid }) {
      uid
      first_publication_date
      last_publication_date
      data {
        header_image {
          localFile {
            childImageSharp {
              fluid( maxWidth: 900 maxHeight: 900 quality: 90 traceSVG: { color: "#021212" } cropFocus: ENTROPY) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
        title {
          text
        }
        subtitle {
          text
        }
        content {
          html
        }
        project_goal {
          html
        }
        process {
          html
        }
        outcome {
          html
        }
        client_descriptor {
          html
        }
        tech_used {
          html
        }
        body {
          ... on PrismicCaseStudyBodyImageGallery {
            id
            items {
              gallery_image {
                alt
                copyright
                url
              }
            }
          }
        }
      }
    }
  }
`;